
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.59961 4.3999H3.79963H13.3998","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.59983 4.40003V3.20002C5.59983 2.88175 5.72626 2.57652 5.95131 2.35148C6.17635 2.12643 6.48158 2 6.79985 2H9.19988C9.51814 2 9.82337 2.12643 10.0484 2.35148C10.2735 2.57652 10.3999 2.88175 10.3999 3.20002V4.40003M12.1999 4.40003V12.8001C12.1999 13.1184 12.0735 13.4236 11.8484 13.6487C11.6234 13.8737 11.3182 14.0002 10.9999 14.0002H4.99982C4.68156 14.0002 4.37633 13.8737 4.15128 13.6487C3.92623 13.4236 3.7998 13.1184 3.7998 12.8001V4.40003H12.1999Z","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.2002 7.3999V11","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.7998 7.3999V11","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    